import React, {useContext} from "react";
import {TemplateContext} from "../common/TemplateContext";
import ResourceNavigation from "./ResourceNavigation";
import CMSResourceNavigation from "./CMSResourceNavigation";
import ClassNavigation from "./ClassNavigation";
import LessonNavigation from "./LessonNavigation";
import {UserContext} from "../common/UserContext";
import TestNavigation from "./TestNavigation";
import TrailNavigation from "./TrailNavigation";
import PreviousNextLesson from "./PreviousNextLesson";
import NavAccessibilityWrap from "./NavAccessibilityWrap";
import {PageMarkerNavigation} from "./PageMarkerNavigation";

const ActivityNavigation = props => {
    const {activityShortcuts} = props;
    const {user, setUser, menuPosition} = useContext(UserContext);
    const {shortcutLocation} = useContext(TemplateContext);

    const menuComponents = {
        ResourceNavigation: ResourceNavigation,
        TestNavigation: TestNavigation,
        TrailNavigation: TrailNavigation,
        ClassNavigation: ClassNavigation,
        LessonNavigation: LessonNavigation
    };

    const showPreviousNextNav = (shortcutLocation === 'LESSON' || user.cmsMode);

    return (
        <>
            {showPreviousNextNav && (
                <PreviousNextLesson compressed={menuPosition.rightMenuClosed} />
            )}
            {activityShortcuts !== undefined && activityShortcuts.length > 0 &&
                <NavAccessibilityWrap aria-label="Resource Navigation" className={'ch-page-navigation ch-activity-navigation'} descendantSubMenu={false}>
                    {user.cmsMode &&
                        <CMSResourceNavigation shortcutLocation={shortcutLocation} />
                    }
                    {!user.cmsMode &&
                        <>
                            <PageMarkerNavigation indicatorPlacement="left"/>
                            <ul role="menu" className={'ch-list ch-nav-group'}>
                                {
                                    activityShortcuts.map((shortcut, index) => {
                                        let menuComponent = shortcut.menuComponent ? shortcut.menuComponent : undefined;
                                        const MenuComponentTag = menuComponent !== undefined ? menuComponents[menuComponent] : undefined;

                                        if (MenuComponentTag === undefined) {
                                            return null;
                                        }

                                        if (shortcut.inLesson && shortcutLocation !== 'LESSON') {
                                            return null;
                                        }

                                        if (!shortcut.inLesson && shortcutLocation == 'LESSON') {
                                            return null;
                                        }

                                        return (
                                            <MenuComponentTag key={shortcut.shortcutId} tabIndex={index == 0 ? 0 : -1} shortcut={shortcut} indicatorPlacement="left"/>
                                        )
                                    })
                                }
                            </ul>
                        </>
                    }
                </NavAccessibilityWrap>
            }
        </>
    )
}

export default ActivityNavigation;